import { Link, NavLink, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Brand from "@/components/Brand";
import { Sparkles, History as HistoryIcon, Settings as SettingsIcon, LogOut } from "lucide-react";
import api from "@/lib/api";

export default function Navbar() {
  const navigate = useNavigate();
  const [email, setEmail] = useState(localStorage.getItem("participant_email") || "");

  useEffect(() => {
    setEmail(localStorage.getItem("participant_email") || "");
  }, []);

  const link = ({ isActive }) =>
    `flex items-center gap-2 px-3 py-2 rounded-md text-sm transition-colors ${
      isActive ? "bg-amber-500/10 text-amber-400" : "text-neutral-400 hover:text-white hover:bg-white/5"
    }`;

  const logout = async () => {
    try {
      await api.post("/participant/logout");
    } catch (_) {
      // ignore — token may already be invalid
    }
    localStorage.removeItem("participant_token");
    localStorage.removeItem("participant_email");
    localStorage.removeItem("participant_session_id");
    navigate("/login");
  };

  return (
    <header
      className="sticky top-0 z-40 backdrop-blur-xl bg-black/70 border-b border-white/10"
      data-testid="participant-navbar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/generator" className="flex items-center" data-testid="navbar-brand-link">
          <Brand size="sm" showTagline={false} />
        </Link>
        <nav className="hidden md:flex items-center gap-1">
          <NavLink to="/generator" className={link} data-testid="nav-generator">
            <Sparkles size={16} /> Penjana
          </NavLink>
          <NavLink to="/history" className={link} data-testid="nav-history">
            <HistoryIcon size={16} /> Sejarah
          </NavLink>
          <NavLink to="/settings" className={link} data-testid="nav-settings">
            <SettingsIcon size={16} /> Tetapan
          </NavLink>
        </nav>
        <div className="flex items-center gap-3">
          <span className="hidden sm:block text-xs text-neutral-500 font-mono" data-testid="nav-email">
            {email}
          </span>
          <button
            onClick={logout}
            className="flex items-center gap-2 px-3 py-2 rounded-md text-sm text-neutral-400 hover:text-amber-400 hover:bg-white/5 transition-colors"
            data-testid="nav-logout-btn"
          >
            <LogOut size={16} /> Keluar
          </button>
        </div>
      </div>
    </header>
  );
}
